
import * as ipxRuntime$e7yLZiyZWtVtO1_2OdUWRGOBNqZoR09hw3o5fHHrujQ from '/var/www/cloud-website/node_modules/@nuxt/image/dist/runtime/providers/ipx'

export const imageOptions = {
  "screens": {
    "xs": 320,
    "sm": 600,
    "md": 960,
    "lg": 1280,
    "xl": 1920,
    "xxl": 2560,
    "2xl": 1536
  },
  "presets": {},
  "provider": "ipx",
  "domains": [],
  "alias": {},
  "densities": [
    1,
    2
  ],
  "format": [
    "webp"
  ]
}

imageOptions.providers = {
  ['ipx']: { provider: ipxRuntime$e7yLZiyZWtVtO1_2OdUWRGOBNqZoR09hw3o5fHHrujQ, defaults: {} }
}
        